import { render, staticRenderFns } from "./custom-company-header.vue?vue&type=template&id=57bf5834&scoped=true&"
import script from "./custom-company-header.vue?vue&type=script&lang=js&"
export * from "./custom-company-header.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-header.vue?vue&type=style&index=0&id=57bf5834&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bf5834",
  null
  
)

export default component.exports